import {
  NewSubscriptionsListDashboardRestEndpointService,
  type NewSubscriptionsListResponse,
} from '@api'
import { attach, createEffect, createStore, sample } from 'effector'
import { matchPath } from 'react-router'

import { Pages } from '@/consts/routes.ts'
import { $creatorId, $currentCreator } from '@/models/creators.ts'
import { initializeApp } from '@/models/init.ts'
import { $currentPage } from '@/models/router.ts'
import { toast } from '@/models/toasts.ts'
import { handleError } from '@/utils/error.ts'

export const getNewSubsListFx = attach({
  name: 'get new subs list',
  source: { creatorId: $creatorId },
  mapParams: (_: void, { creatorId }) => ({
    onlyfansId: creatorId!,
  }),
  effect: createEffect(
    NewSubscriptionsListDashboardRestEndpointService.newSubscriptionsListResponse,
  ),
})

export const updateNewSubsListFx = attach({
  name: 'update new subs list',
  source: { creatorId: $creatorId },
  // @ts-ignore
  mapParams: (id: string, { creatorId }) => ({
    onlyfansId: creatorId!,
    requestBody: {
      id,
      name: '',
    },
  }),
  effect: createEffect(
    // TODO: bad swagger types, should be updated
    NewSubscriptionsListDashboardRestEndpointService.setNewSubsList,
  ),
})

updateNewSubsListFx.done.watch(({ params: id }) => {
  // eslint-disable-next-line effector/no-getState
  const activeCreator = $currentCreator.getState()

  toast.success(
    `The new subs list has been updated to "${
      activeCreator?.lists.find((list) => list.id === id)?.name ??
      'Unknown list'
    }".`,
  )
})

updateNewSubsListFx.failData.watch((error) => {
  handleError(error, 'Failed setting new subs list.')
})

export const removeNewSubsListFx = attach({
  name: 'remove tier',
  source: { creatorId: $creatorId },
  mapParams: (_: void, { creatorId }) => ({
    onlyfansId: creatorId!,
  }),
  effect: createEffect(
    NewSubscriptionsListDashboardRestEndpointService.removeNewSubsList,
  ),
})

removeNewSubsListFx.doneData.watch(() => {
  toast.success('Removed new subs list')
})

removeNewSubsListFx.failData.watch((error) => {
  handleError(error, 'Failed disabling new subs list.')
})

export const $newSubsList = createStore<Nullable<NewSubscriptionsListResponse>>(
  null,
)
  .on(getNewSubsListFx.doneData, (_, data) => data)
  .reset(getNewSubsListFx, removeNewSubsListFx)

sample({
  clock: [initializeApp, $currentPage, $creatorId],
  source: { path: $currentPage, creatorId: $creatorId },
  filter: ({ path, creatorId }) => {
    const isPathOk = !!matchPath(Pages.CREATOR_NEW_SUBS_LIST, path)

    return !!creatorId && isPathOk
  },
  target: getNewSubsListFx,
})

sample({
  clock: [updateNewSubsListFx.done],
  target: getNewSubsListFx,
})
